import {
    ConfirmAccountPageContainer as SourceConfirmAccountPageContainer,
    mapStateToProps,
    mapDispatchToProps
} from 'SourceRoute/ConfirmAccountPage/ConfirmAccountPage.container';

import { connect } from 'react-redux';

export class ConfirmAccountPageContainer extends SourceConfirmAccountPageContainer {
    _updateBreadcrumbs() {
        const { updateBreadcrumbs } = this.props;
        const breadcrumbs = [
            {
                url: '/account/confirmAccount',
                name: __('Confirm Account')
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAccountPageContainer);
